import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UmbrellaLogo } from "@/components/UmbrellaLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sid = params.get("session_id");
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setUser(r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const role = r.data.user.role;
        navigate(role === "admin" ? "/admin" : role === "business" ? "/business" : "/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500">
      <UmbrellaLogo size={44} className="animate-pulse text-slate-950" />
      <p className="text-sm">Signing you in…</p>
    </div>
  );
}
